var _path, _path2, _g, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFace = function SvgFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 8.76v2.05c-3.35-.08-2.5-.01-3.43-.01-1.53 0-3.05-2.82-3.05-2.82s-.27 1.78.76 3.22c-3.81 0-5.34-4.01-5.34-4.01 0 2.42-2.66 3.61-2.66 3.61l-2.28 1.02v-3.04c0-3.25 2.1-4.45 3.59-4.71.33-.79 1.33-1.99 4.39-2.07 2.37-.06 4.67.77 6.16 2.22 1.22 1.19 1.86 2.76 1.86 4.54z",
    fill: "#607d8b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20 10.81v1.65c0 1.23-.24 2.44-.71 3.59-.18.41-.57 1.1-.61 1.18-1.5 2.49-3.34 4.77-6.68 4.77-3.43 0-5.33-2.45-6.74-4.85-.01-.02-.39-.72-.55-1.09-.47-1.14-.71-2.35-.71-3.59v-.65l2.28-1.02s2.66-1.19 2.66-3.61c0 0 1.53 4.01 5.34 4.01-1.03-1.44-.76-3.22-.76-3.22s1.52 2.82 3.05 2.82c.93 0 .08-.07 3.43.01z",
    fill: "#ffcc80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2196f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23 8c-.552 0-1-.448-1-1v-4c0-.551-.449-1-1-1h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c1.654 0 3 1.346 3 3v4c0 .552-.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 8c-.552 0-1-.448-1-1v-4c0-1.654 1.346-3 3-3h4c.552 0 1 .448 1 1s-.448 1-1 1h-4c-.551 0-1 .449-1 1v4c0 .552-.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 24h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c.551 0 1-.449 1-1v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 1.654-1.346 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 24h-4c-1.654 0-3-1.346-3-3v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 .551.449 1 1 1h4c.552 0 1 .448 1 1s-.448 1-1 1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.001 18.5c-1.003 0-1.943-.402-2.65-1.131-.288-.298-.28-.772.018-1.061s.772-.28 1.061.017c.841.87 2.301.871 3.144 0 .289-.297.765-.305 1.061-.017.298.288.306.763.018 1.061-.71.729-1.65 1.131-2.652 1.131z",
    fill: "#607d8b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face.07bd8ba9.svg";
export { ForwardRef as ReactComponent };